import React from "react";

const SquiggleStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.77496 14.3238C8.50896 16.6513 11.8799 14.3659 13.9261 11.2087C16.2482 7.62597 15.9977 2.40562 12.6932 4.46695C10.2669 6.69188 9.74917 13.7627 13.6857 15.6674C15.7603 16.6713 17.44 15.1309 18 14.6176M5.77496 14.3238C4.01169 12.8227 4.00966 7.58574 6.67168 7.56667C9.33371 7.5476 6.6561 12.7892 5.77496 14.3238ZM5.77496 14.3238C5.77496 14.3238 4.06095 16.7552 2 15.2416",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SquiggleStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;